type Figure={url:string;page:number;alt:string}

/** Display correction; frozen question text, answers and coverage stay untouched. */
export function correctFigureReferences(questionId:string,figures:Figure[]|undefined):Figure[]|undefined{
 if(questionId!=='business-2026-june-1-4-a')return figures
 return figures?.map(figure=>figure.page===2?{...figure,alt:'Business formula sheet, including the acid-test ratio formula. Figure 3 is on question-paper page 16.'}:figure)
}
